import { render } from "./legoList.vue?vue&type=template&id=c6ee2790"
import script from "./legoList.vue?vue&type=script&lang=js"
export * from "./legoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoList/legoList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6ee2790"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6ee2790', __exports__)) {
    api.reload('c6ee2790', __exports__)
  }
  
  module.hot.accept("./legoList.vue?vue&type=template&id=c6ee2790", () => {
    api.rerender('c6ee2790', render)
  })

}


export default __exports__